import styled from 'styled-components';
import { List, ListItem } from './List';

export const Sitemap = styled.div``;

export const SitemapList = List.extend`
  list-style-type: disc;
  list-style-position: outside;
  margin: 0 0 10px;

  ${ListItem} {
    margin: 0 0 0 20px;
  }

  ${List} {
    list-style-type: circle;
  }
`;

export const SitemapTitle = styled.span`
  font-size: 1.8rem;
  line-height: 2.4rem;
  font-weight: bold;
  display: block;
  padding: 5px 0;
`;
